/* Hotsale skin for one Colombia product. Does not change order data. */
(function () {
  'use strict';

  var PRODUCT_IDS = {
    '10302945067226': true,
    '10302922326234': true,
    '15268359471322': true,
    '15268384473306': true
  };

  function productId() {
    try {
      var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      if (meta && meta.id) return String(meta.id);
    } catch (e) {}
    var el = document.querySelector('[data-product-id]');
    if (el) return String(el.getAttribute('data-product-id'));
    return '';
  }

  var KIT_PRODUCT_IDS = {
    '15268384473306': true
  };

  function isListedProduct() {
    return !!PRODUCT_IDS[productId()];
  }

  function isKitProduct() {
    return !!KIT_PRODUCT_IDS[productId()];
  }

  function isTarget() {
    if (document.body && document.body.classList.contains('sv-hotsale')) return true;
    return isListedProduct();
  }

  function markBody() {
    if (!document.body) return;
    if (isListedProduct()) document.body.classList.add('sv-hotsale');
    if (isKitProduct()) document.body.classList.add('sv-hotsale-kit');
  }

  function isNoThanks(btn) {
    var text = (btn.textContent || '').toLowerCase();
    return btn.classList.contains('_rsi-modal-submit-button-upsell-no-thanks') || text.indexOf('no, gracias') !== -1 || text.indexOf('rechazar') !== -1;
  }

  function paintBuyButton() {
    document.querySelectorAll('._rsi-buy-now-button').forEach(function (btn) {
      if (isNoThanks(btn) || btn.dataset.svHs || btn.querySelector('.sv-hs-fire')) {
        btn.dataset.svHs = '1';
        return;
      }
      var fire = document.createElement('span');
      fire.className = 'sv-hs-fire';
      fire.setAttribute('aria-hidden', 'true');
      fire.textContent = '🔥 ';
      var span = null;
      for (var i = 0; i < btn.children.length; i++) {
        if (btn.children[i].tagName === 'SPAN' && !btn.children[i].classList.contains('sv-hs-fire')) {
          span = btn.children[i];
          break;
        }
      }
      if (span) span.insertBefore(fire, span.firstChild);
      else btn.insertBefore(fire, btn.firstChild);
      btn.dataset.svHs = '1';
    });
  }

  var COUNTDOWN_MINUTES = 15;
  var countdownEnd = 0;

  function countdownLabel() {
    if (!countdownEnd) countdownEnd = Date.now() + COUNTDOWN_MINUTES * 60 * 1000;
    var left = Math.max(0, countdownEnd - Date.now());
    var total = Math.ceil(left / 1000);
    var minutes = Math.floor(total / 60);
    var seconds = total % 60;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    return 'TERMINA EN ' + pad(minutes) + ':' + pad(seconds);
  }

  function paintHeader(form) {
    var header = form.querySelector('._rsi-modal-header');
    if (!header) return;
    if (!header.querySelector('.sv-hs-banner')) {
      var banner = document.createElement('div');
      banner.className = 'sv-hs-banner';
      banner.textContent = '🔥 HOTSALE';
      header.insertBefore(banner, header.firstChild);
    }
    header.querySelectorAll('._rsi-modal-header-title, ._rsi-modal-header-title-centered').forEach(function (title) {
      var label = countdownLabel();
      if (title.textContent !== label) title.textContent = label;
      title.style.setProperty('color', '#ffffff', 'important');
      title.style.setProperty('-webkit-text-fill-color', '#ffffff', 'important');
    });
  }

  function placePlaques(form) {
    form.querySelectorAll('._rsi-quantity-offers-offer-container').forEach(function (card) {
      var prices = card.querySelector('._rsi-quantity-offers-prices');
      var plaque = card.querySelector('._rsi-quantity-offers-plaque-container');
      if (!prices || !plaque || plaque.parentNode === prices) return;
      prices.insertBefore(plaque, prices.firstChild);
    });
  }

  function paintBadge(form) {
    form.querySelectorAll('._rsi-quantity-offers-offer-container').forEach(function (card) {
      if (card.querySelector('.sv-hs-hot')) return;
      var title = card.querySelector('._rsi-quantity-offers-title');
      if (!title) return;
      var txt = (title.textContent || '').replace(/\s+/g, ' ');
      if (!/3 pares y ll[eé]vate 4/i.test(txt) && !/3 pares \+ 3 gratis/i.test(txt)) return;
      var badge = document.createElement('div');
      badge.className = 'sv-hs-hot';
      badge.textContent = '🔥 Más elegido';
      var info = card.querySelector('._rsi-quantity-offers-info') || title.parentNode;
      info.insertBefore(badge, title);
    });
  }

  function enhancePhone(form) {
    var input = form.querySelector('input[data-type="phone"]');
    if (!input) return;
    var item = input.closest('._rsi-modal-fields-item');
    if (!item) return;

    item.classList.add('sv-hs-phone-item');
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('maxlength', '10');
    input.setAttribute('placeholder', '300 000 0000');
    input.setAttribute('aria-label', 'Teléfono, código de país +57');

    if (!item.querySelector('.sv-hs-phone-prefix')) {
      var prefix = document.createElement('span');
      prefix.className = 'sv-hs-phone-prefix';
      prefix.setAttribute('aria-hidden', 'true');
      prefix.textContent = '+57';
      item.insertBefore(prefix, input);
    }

    if (input.dataset.svHsPhone) return;
    input.dataset.svHsPhone = '1';
    input.addEventListener('input', function () {
      var digits = input.value.replace(/\D/g, '');
      if (digits.length > 10 && digits.slice(0, 2) === '57') digits = digits.slice(2);
      input.value = digits.slice(0, 10);
    });
  }

  function keyboardFields(form) {
    return Array.prototype.filter.call(form.querySelectorAll(
      '._rsi-modal-fields-item:not(._rsi-modal-fields-checkbox) input:not([type="hidden"]):not([disabled]),' +
      '._rsi-modal-fields-item:not(._rsi-modal-fields-checkbox) select:not([disabled]),' +
      '._rsi-modal-fields-item:not(._rsi-modal-fields-checkbox) textarea:not([disabled])'
    ), function (field) {
      var style = window.getComputedStyle(field);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
  }

  function enhanceKeyboardFlow(form) {
    var fields = keyboardFields(form);
    fields.forEach(function (field, index) {
      if (field.tagName !== 'INPUT' && field.tagName !== 'TEXTAREA') return;
      field.setAttribute('enterkeyhint', index < fields.length - 1 ? 'next' : 'done');
    });

    if (form.dataset.svHsKeyboard) return;
    form.dataset.svHsKeyboard = '1';
    var lastKeyboardAdvance = 0;

    form.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' || event.isComposing) return;
      var target = event.target;
      if (!target || (target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA')) return;
      if (target.tagName === 'TEXTAREA') return;
      var currentFields = keyboardFields(form);
      var index = currentFields.indexOf(target);
      if (index === -1) return;

      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      lastKeyboardAdvance = Date.now();

      var next = currentFields[index + 1];
      if (next) {
        next.focus({ preventScroll: false });
        if (next.scrollIntoView) next.scrollIntoView({ block: 'center', behavior: 'smooth' });
      } else {
        target.blur();
      }
    }, true);

    form.addEventListener('submit', function (event) {
      if (Date.now() - lastKeyboardAdvance > 900) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }, true);
  }

  function polishShippingRate(form) {
    form.querySelectorAll('._rsi-modal-shipping-rates-item-title').forEach(function (title) {
      var text = (title.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/entrega\s+gratis\s+nacional/i.test(text) || title.dataset.svHsShipping) return;
      title.dataset.svHsShipping = '1';
      title.classList.add('sv-hs-shipping-copy');
      title.innerHTML =
        '<strong>Envío GRATIS a todo Colombia</strong>' +
        '<small>2–3 días hábiles en ciudades principales · 5 días o más en otros municipios</small>';
    });
  }

  function pinUpsellFirstImage() {
    var upsell = document.querySelector('#_rsi-cod-form-modal-upsell');
    if (!upsell) return;
    var slider = upsell.querySelector('._rsi-modal-upsell-images-slider');
    var container = slider && slider.querySelector('.slider-container');
    if (!container || !container.children.length) return;
    slider.classList.add('sv-hs-upsell-first-only');
    for (var i = 0; i < container.children.length; i++) {
      container.children[i].classList.toggle('sv-hs-upsell-first-image', i === 0);
    }
    container.scrollLeft = 0;
  }

  function paintButton(el, bg) {
    el.style.setProperty('background', bg, 'important');
    el.style.setProperty('background-color', bg, 'important');
    el.style.setProperty('border-color', bg, 'important');
    el.style.setProperty('color', '#ffffff', 'important');
    el.querySelectorAll('span').forEach(function (span) {
      span.style.setProperty('color', '#ffffff', 'important');
      span.style.setProperty('-webkit-text-fill-color', '#ffffff', 'important');
    });
  }

  function hideAviso(root) {
    (root || document).querySelectorAll('img').forEach(function (img) {
      var src = img.getAttribute('src') || '';
      if (src.indexOf('Batata_2.png') === -1) return;
      var block = img.closest('._rsi-build-block') || img.parentElement;
      if (block) block.style.setProperty('display', 'none', 'important');
      img.style.setProperty('display', 'none', 'important');
    });
  }

  function paintPayButtons() {
    document.querySelectorAll('._rsi-buy-now-button, ._rsi-modal-submit-button, ._rsi-modal-submit-button-upsell-no-thanks').forEach(function (btn) {
      var prepaid = btn.classList.contains('_rsi-buy-now-custom-additionals-button');
      var no = isNoThanks(btn);
      btn.dataset.svColored = '1';
      paintButton(btn, no || prepaid ? '#192d52' : '#ff6427');
      if (no) {
        btn.childNodes.forEach(function (node) {
          if (node.nodeType === 3) node.textContent = node.textContent.replace(/^\s*🔥\s*/, '');
        });
        btn.querySelectorAll('span').forEach(function (span) {
          span.textContent = span.textContent.replace(/^\s*🔥\s*/, '');
        });
      }
    });
  }

  function isPlaceholder(sel) {
    if (!sel) return true;
    var op = sel.options[sel.selectedIndex];
    var text = op ? (op.text || '').trim() : '';
    return !sel.value || /^selecciona\b/i.test(text);
  }

  function realValue(sel, wanted) {
    if (!sel) return '';
    var fallback = '';
    for (var i = 0; i < sel.options.length; i++) {
      var op = sel.options[i];
      var text = (op.text || '').trim();
      if (!op.value || /^selecciona\b/i.test(text)) continue;
      if (!fallback) fallback = op.value;
      if (wanted && (op.value === wanted || text === wanted)) return op.value;
    }
    return fallback;
  }

  function activeVariantBox(form) {
    if (!form) return null;
    return form.querySelector('._rsi-quantity-offers-selected ._rsi-quantity-offers-variants-multi-selectors')
      || form.querySelector('._rsi-quantity-offers-selected ._rsi-quantity-offers-variants');
  }

  function isMultiBox(box) {
    return !!(box && box.querySelector('._rsi-quantity-offers-variant-selector-multi-sel'));
  }

  function isKitBox(box) {
    return !!(box && (isKitProduct() || box.querySelector('.sv-hs-kit-talla')));
  }

  var KIT_SIZE_RE = /^(S|M|L|XL|XXL|2XL|3XL)$/i;
  var SHOE_SIZE_RE = /^\d{2}(-\d{2})?$/;

  function parseVariantLabel(text) {
    var parts = String(text || '').split(/\s*\/\s*/);
    var kit = '';
    var shoe = '';
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].replace(/\s+/g, ' ').trim();
      if (KIT_SIZE_RE.test(part)) kit = part.toUpperCase().replace(/^XXL$/, '2XL');
      else if (SHOE_SIZE_RE.test(part)) shoe = part;
    }
    return { kit: kit, shoe: shoe };
  }

  function kitRowSelect(row) {
    if (!row) return null;
    return row.querySelector('select[data-option-num]') ? null : row.querySelector('select[data-offer-num], select');
  }

  function isKitCombined(box) {
    if (!isKitBox(box)) return false;
    var rows = variantRows(box);
    return !!(rows.length && kitRowSelect(rows[0]));
  }

  function kitOptionMap(box) {
    var map = { kit: '0', shoe: '1', extra: [] };
    if (!box) return map;
    var seen = {};
    box.querySelectorAll('select[data-option-num]').forEach(function (sel) {
      var num = sel.getAttribute('data-option-num');
      if (!num || seen[num]) return;
      seen[num] = true;
      var texts = Array.prototype.map.call(sel.options, function (op) {
        return (op.textContent || '').trim();
      });
      var kitHits = texts.filter(function (t) { return KIT_SIZE_RE.test(t); }).length;
      var shoeHits = texts.filter(function (t) { return SHOE_SIZE_RE.test(t); }).length;
      var host = sel.closest('._rsi-quantity-offers-variant-selector-multi-sel-container, ._rsi-quantity-offers-variant-selector');
      var nameEl = host && host.querySelector('._rsi-quantity-offers-multi-sel-optname, ._rsi-quantity-offers-optname');
      var name = (nameEl && nameEl.textContent || '').trim();
      if (/talla\s*kit/i.test(name) || (kitHits >= 3 && kitHits >= shoeHits)) map.kit = num;
      else if (/talla\s*(calzado|descalz)/i.test(name) || (shoeHits >= 5 && shoeHits > kitHits)) map.shoe = num;
      else map.extra.push(num);
    });
    return map;
  }

  function kitSizeOrder(a, b) {
    var order = { S: 1, M: 2, L: 3, XL: 4, '2XL': 5, XXL: 5, '3XL': 6 };
    var aa = order[String(a).toUpperCase()] || 50;
    var bb = order[String(b).toUpperCase()] || 50;
    return aa === bb ? String(a).localeCompare(String(b)) : aa - bb;
  }

  function collectKitOptions(sel) {
    var kits = [];
    var shoesByKit = {};
    var seenKit = {};
    if (!sel) return { kits: kits, shoesByKit: shoesByKit };
    Array.prototype.forEach.call(sel.options, function (op) {
      if (!op.value || /^selecciona\b/i.test((op.text || '').trim())) return;
      var parsed = parseVariantLabel(op.text);
      if (!parsed.kit || !parsed.shoe) return;
      if (!seenKit[parsed.kit]) {
        seenKit[parsed.kit] = true;
        kits.push(parsed.kit);
      }
      if (!shoesByKit[parsed.kit]) shoesByKit[parsed.kit] = [];
      if (shoesByKit[parsed.kit].indexOf(parsed.shoe) === -1) shoesByKit[parsed.kit].push(parsed.shoe);
    });
    kits.sort(kitSizeOrder);
    Object.keys(shoesByKit).forEach(function (key) {
      shoesByKit[key].sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
    });
    return { kits: kits, shoesByKit: shoesByKit };
  }

  function shoesForKit(info, kit) {
    if (kit && info.shoesByKit[kit] && info.shoesByKit[kit].length) return info.shoesByKit[kit];
    var seen = {};
    var list = [];
    Object.keys(info.shoesByKit).forEach(function (key) {
      info.shoesByKit[key].forEach(function (shoe) {
        if (seen[shoe]) return;
        seen[shoe] = true;
        list.push(shoe);
      });
    });
    list.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
    return list;
  }

  function findCombinedValue(sel, kit, shoe) {
    if (!sel || !kit || !shoe) return '';
    var wantKit = String(kit).toUpperCase();
    var wantShoe = String(shoe);
    for (var i = 0; i < sel.options.length; i++) {
      var op = sel.options[i];
      if (!op.value) continue;
      var parsed = parseVariantLabel(op.text);
      if (parsed.kit.toUpperCase() === wantKit && parsed.shoe === wantShoe) return op.value;
    }
    return '';
  }

  function variantRows(box) {
    if (isMultiBox(box)) return box.querySelectorAll('._rsi-quantity-offers-variant-selector-multi-sel');
    return box.querySelectorAll('._rsi-quantity-offers-variant-selector');
  }

  function exactValue(sel, wanted) {
    if (!sel || !wanted) return '';
    for (var i = 0; i < sel.options.length; i++) {
      var op = sel.options[i];
      var text = (op.text || '').trim();
      if (!op.value || /^selecciona\b/i.test(text)) continue;
      if (op.value === wanted || text === wanted) return op.value;
    }
    return '';
  }

  function commitRows(box) {
    var rows = variantRows(box);
    if (!rows.length) return;
    var same = box.classList.contains('sv-hs-variants-collapsed');
    if (isKitBox(box)) {
      var kitChip = box.querySelector('.sv-hs-chips[data-sv-opt="0"] .sv-hs-chip.is-on, .sv-hs-chips[data-sv-opt="kit"] .sv-hs-chip.is-on');
      var kitWant = kitChip ? kitChip.getAttribute('data-val') : '';
      var barTalla = box.querySelector('.sv-hs-kit-talla');
      var tallaWant = barTalla && barTalla.value ? barTalla.value : '';
      if (isKitCombined(box)) {
        rows.forEach(function (row) {
          var combined = kitRowSelect(row);
          if (!combined) return;
          var val = findCombinedValue(combined, kitWant, tallaWant);
          if (val && combined.value !== val) {
            combined.value = val;
            combined.dispatchEvent(new Event('change', { bubbles: true }));
          }
          combined.removeAttribute('required');
        });
        return;
      }
      var kitMap = kitOptionMap(box);
      rows.forEach(function (row) {
        var kit = row.querySelector('select[data-option-num="' + kitMap.kit + '"]');
        var talla = row.querySelector('select[data-option-num="' + kitMap.shoe + '"]');
        var changed = false;
        kitMap.extra.forEach(function (num) {
          var extra = row.querySelector('select[data-option-num="' + num + '"]');
          var ev = extra && realValue(extra, extra.value);
          if (extra && ev && extra.value !== ev) {
            extra.value = ev;
            changed = true;
          }
        });
        if (kit && kitWant) {
          var kv = exactValue(kit, kitWant);
          if (kv && kit.value !== kv) {
            kit.value = kv;
            changed = true;
          }
        }
        if (talla && tallaWant && (same || isPlaceholder(talla))) {
          var tv = exactValue(talla, tallaWant);
          if (tv && talla.value !== tv) {
            talla.value = tv;
            changed = true;
          }
        }
        if (changed) {
          var trigger = talla && !isPlaceholder(talla) ? talla : kit;
          if (trigger) trigger.dispatchEvent(new Event('change', { bubbles: true }));
        }
        row.querySelectorAll('select').forEach(function (sel) { sel.removeAttribute('required'); });
      });
      return;
    }
    if (!isMultiBox(box)) {
      var tallaChip = box.querySelector('.sv-hs-chips[data-sv-opt="talla"] .sv-hs-chip.is-on');
      var tallaWant = tallaChip ? tallaChip.getAttribute('data-val') : '';
      rows.forEach(function (row) {
        var talla = row.querySelector('select');
        if (!talla) return;
        if (tallaWant && (same || isPlaceholder(talla))) {
          var tv = exactValue(talla, tallaWant);
          if (tv && talla.value !== tv) {
            talla.value = tv;
            talla.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        talla.removeAttribute('required');
      });
      return;
    }
    var colorChip = box.querySelector('.sv-hs-chips[data-sv-opt="0"] .sv-hs-chip.is-on');
    var multiTallaChip = box.querySelector('.sv-hs-chips[data-sv-opt="1"] .sv-hs-chip.is-on');
    var colorWant = colorChip ? colorChip.getAttribute('data-val') : '';
    var multiTallaWant = multiTallaChip ? multiTallaChip.getAttribute('data-val') : '';
    rows.forEach(function (row) {
      var color = row.querySelector('select[data-option-num="0"]');
      var talla = row.querySelector('select[data-option-num="1"]');
      var changed = false;
      if (color && (same || isPlaceholder(color))) {
        var cv = realValue(color, colorWant);
        if (cv && color.value !== cv) {
          color.value = cv;
          changed = true;
        }
      }
      if (talla && multiTallaWant && (same || isPlaceholder(talla))) {
        var nextTalla = realValue(talla, multiTallaWant);
        if (nextTalla && talla.value !== nextTalla) {
          talla.value = nextTalla;
          changed = true;
        }
      }
      if (changed) {
        var trigger = talla && talla.value ? talla : color;
        if (trigger) trigger.dispatchEvent(new Event('change', { bubbles: true }));
      }
      row.querySelectorAll('select').forEach(function (sel) { sel.removeAttribute('required'); });
    });
  }

  function selectionReady(box) {
    var rows = variantRows(box);
    if (!rows.length) return false;
    var multi = isMultiBox(box);
    if (isKitBox(box)) {
      if (!box.querySelector('.sv-hs-chips[data-sv-opt="0"] .sv-hs-chip.is-on, .sv-hs-chips[data-sv-opt="kit"] .sv-hs-chip.is-on')) return false;
      var shoeSel = box.querySelector('.sv-hs-kit-talla');
      if (shoeSel && isPlaceholder(shoeSel)) return false;
      if (isKitCombined(box)) {
        return Array.prototype.every.call(rows, function (row) {
          return !isPlaceholder(kitRowSelect(row));
        });
      }
      var readyMap = kitOptionMap(box);
      return Array.prototype.every.call(rows, function (row) {
        return !isPlaceholder(row.querySelector('select[data-option-num="' + readyMap.kit + '"]'))
          && !isPlaceholder(row.querySelector('select[data-option-num="' + readyMap.shoe + '"]'));
      });
    }
    return Array.prototype.every.call(rows, function (row) {
      if (!multi) return !isPlaceholder(row.querySelector('select'));
      var color = row.querySelector('select[data-option-num="0"]');
      var talla = row.querySelector('select[data-option-num="1"]');
      var variant = row.querySelector('input[data-offer-num]');
      return !isPlaceholder(color) && !isPlaceholder(talla) && (!variant || !!variant.value);
    });
  }

  function clearSelectionError(box) {
    box.classList.remove('sv-hs-selection-invalid');
    var error = box.querySelector('.sv-hs-selection-error');
    if (error) error.classList.remove('is-visible');
  }

  function showSelectionError(box) {
    box.classList.add('sv-hs-selection-invalid');
    var error = box.querySelector('.sv-hs-selection-error');
    if (error) error.classList.add('is-visible');
    var target = box.querySelector('.sv-hs-same') || box;
    if (target.scrollIntoView) target.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function buildChips(box) {
    var ready = true;
    var built = false;
    box.querySelectorAll('.sv-hs-chips').forEach(function (wrap) {
      var opt = wrap.getAttribute('data-sv-opt');
      var kitChip = isKitBox(box) && (opt === '0' || opt === 'kit');
      var combined = kitChip && isKitCombined(box);
      var kitMap = !combined && isKitBox(box) ? kitOptionMap(box) : null;
      var sel = opt === 'talla'
        ? box.querySelector('._rsi-quantity-offers-variant-selector select')
        : box.querySelector('select[data-option-num="' + ((kitMap && kitChip) ? kitMap.kit : opt) + '"]');
      var kitInfo = combined ? collectKitOptions(kitRowSelect(variantRows(box)[0])) : null;
      if (combined) {
        if (!kitInfo.kits.length) {
          ready = false;
          return;
        }
      } else if (!sel || !sel.options.length) {
        ready = false;
        return;
      }
      var current = wrap.getAttribute('data-sv-built');
      var signature = combined
        ? kitInfo.kits.join('|')
        : Array.prototype.map.call(sel.options, function (op) { return op.value; }).join('|');
      if (current === signature) return;
      built = true;
      wrap.innerHTML = '';
      wrap.setAttribute('data-sv-built', signature);
      var label = document.createElement('div');
      label.className = 'sv-hs-chips__label';
      var host = sel && sel.closest('._rsi-quantity-offers-variant-selector-multi-sel-container');
      var nameEl = host && host.querySelector('._rsi-quantity-offers-multi-sel-optname');
      label.textContent = opt === '1' || opt === 'talla'
        ? 'Talla *'
        : (kitChip ? 'Talla kit *' : (nameEl ? nameEl.textContent : 'Color'));
      wrap.appendChild(label);
      var values = combined
        ? kitInfo.kits.map(function (kit) { return { value: kit, text: kit }; })
        : Array.prototype.filter.call(sel.options, function (op) {
          var text = (op.textContent || '').trim();
          return op.value && !/^selecciona\b/i.test(text);
        }).map(function (op) {
          return { value: op.value, text: (op.textContent || '').trim() };
        });
      if (!values.length) {
        ready = false;
        return;
      }
      var hasSelected = !combined && values.some(function (item) { return item.value === sel.value; });
      var selected = '';
      if (kitChip) {
        selected = '';
      } else if (hasSelected) {
        selected = sel.value;
      } else if (opt === '0') {
        selected = values[0].value;
      }
      values.forEach(function (item) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'sv-hs-chip' + (item.value === selected ? ' is-on' : '');
        chip.setAttribute('data-val', item.value);
        chip.setAttribute('aria-pressed', item.value === selected ? 'true' : 'false');
        chip.textContent = item.text;
        chip.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          wrap.querySelectorAll('.sv-hs-chip').forEach(function (el) {
            el.classList.toggle('is-on', el === chip);
            el.setAttribute('aria-pressed', el === chip ? 'true' : 'false');
          });
          fillKitTallaSelect(box);
          commitRows(box);
          if (selectionReady(box)) clearSelectionError(box);
        });
        wrap.appendChild(chip);
      });
    });
    if (built && ready) commitRows(box);
    fillKitTallaSelect(box);
    return ready;
  }

  function fillKitTallaSelect(box) {
    if (!isKitBox(box)) return;
    var select = box.querySelector('.sv-hs-kit-talla');
    if (!select) return;
    var combined = isKitCombined(box);
    var kitChip = box.querySelector('.sv-hs-chips[data-sv-opt="0"] .sv-hs-chip.is-on, .sv-hs-chips[data-sv-opt="kit"] .sv-hs-chip.is-on');
    var kitWant = kitChip ? kitChip.getAttribute('data-val') : '';
    var shoes = [];
    var source = null;
    if (combined) {
      var info = collectKitOptions(kitRowSelect(variantRows(box)[0]));
      shoes = shoesForKit(info, kitWant);
    } else {
      source = box.querySelector('select[data-option-num="' + kitOptionMap(box).shoe + '"]');
      if (!source || !source.options.length) return;
      Array.prototype.forEach.call(source.options, function (op) {
        var text = (op.textContent || '').trim();
        if (!op.value || /^selecciona\b/i.test(text)) return;
        shoes.push(text);
      });
    }
    var signature = (kitWant || '') + '::' + shoes.join('|');
    if (select.getAttribute('data-sv-built') === signature) {
      bindKitTalla(select, box);
      return;
    }
    var keep = select.value;
    select.innerHTML = '';
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Selecciona talla';
    select.appendChild(placeholder);
    shoes.forEach(function (text) {
      var copy = document.createElement('option');
      copy.value = text;
      copy.textContent = text;
      if (keep && keep === text) copy.selected = true;
      select.appendChild(copy);
    });
    select.setAttribute('data-sv-built', signature);
    bindKitTalla(select, box);
  }

  function bindKitTalla(select, box) {
    if (select.dataset.svBound) return;
    select.dataset.svBound = '1';
    select.addEventListener('change', function (event) {
      event.stopPropagation();
      commitRows(box);
      if (selectionReady(box)) clearSelectionError(box);
    });
  }

  function enhanceVariants(form) {
    var box = activeVariantBox(form);
    if (!box) return;
    if (isKitCombined(box)) box.classList.add('sv-hs-kit-combined');
    else box.classList.remove('sv-hs-kit-combined');
    if (isKitProduct() && isMultiBox(box) && box.querySelector('.sv-hs-same') && !box.querySelector('.sv-hs-kit-talla')) {
      box.querySelector('.sv-hs-same').remove();
    }
    if (!box.querySelector('.sv-hs-same')) {
      var kit = isKitProduct();
      var single = !isMultiBox(box);
      var rows = variantRows(box);
      var bar = document.createElement('div');
      bar.className = 'sv-hs-same';
      var toggleHtml = rows.length > 1
        ? '<button type="button" class="sv-hs-toggle" aria-expanded="false" title="Elegir talla para cada par">Elegir por par</button>'
        : '';
      bar.innerHTML = kit
        ? '<div class="sv-hs-row sv-hs-row-kit">' +
            '<div class="sv-hs-chips" data-sv-opt="0"></div>' +
            '<div class="sv-hs-kit-talla-wrap">' +
              '<div class="sv-hs-chips__label">Talla calzado *</div>' +
              '<select class="sv-hs-kit-talla" aria-label="Talla del calzado"><option value="">Selecciona talla</option></select>' +
            '</div>' +
            toggleHtml +
          '</div>' +
          '<p class="sv-hs-selection-error" role="alert" aria-live="polite">Selecciona el kit y la talla para continuar.</p>'
        : single
        ? '<div class="sv-hs-row sv-hs-row-single">' +
            '<div class="sv-hs-chips" data-sv-opt="talla"></div>' +
            toggleHtml +
          '</div>' +
          '<p class="sv-hs-selection-error" role="alert" aria-live="polite">Selecciona una talla para continuar.</p>'
        : '<div class="sv-hs-row">' +
            '<div class="sv-hs-chips" data-sv-opt="0"></div>' +
            '<div class="sv-hs-chips" data-sv-opt="1"></div>' +
            '<button type="button" class="sv-hs-toggle" aria-expanded="false" title="Elegir color y talla para cada par">Elegir por par</button>' +
          '</div>' +
          '<p class="sv-hs-selection-error" role="alert" aria-live="polite">Selecciona una talla para continuar.</p>';
      box.insertBefore(bar, box.firstChild);
      box.classList.add('sv-hs-variants-collapsed');
      var toggle = bar.querySelector('.sv-hs-toggle');
      if (toggle) toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var open = box.classList.toggle('sv-hs-variants-open');
        box.classList.toggle('sv-hs-variants-collapsed', !open);
        this.textContent = open ? 'Mismo para todos' : 'Elegir por par';
        this.setAttribute('aria-expanded', open ? 'true' : 'false');
        this.setAttribute('title', open ? 'Usar la misma talla para todos' : (single ? 'Elegir talla para cada par' : 'Elegir color y talla para cada par'));
        if (!open) {
          commitRows(box);
          if (selectionReady(box)) clearSelectionError(box);
        }
      });
      box.addEventListener('change', function () {
        if (selectionReady(box)) clearSelectionError(box);
      });
    }
    buildChips(box);
  }

  function fieldLabel(item) {
    var label = item.querySelector('label');
    var text = label ? (label.textContent || '') : '';
    text = text.replace('*', '').replace(/\s+/g, ' ').trim();
    return text || 'Este campo';
  }

  function explainErrors(form) {
    var items = form.querySelectorAll('._rsi-modal-fields-item-error');
    items.forEach(function (item) {
      var input = item.querySelector('input, select, textarea');
      var type = input ? input.getAttribute('data-type') || '' : '';
      var msg = 'Completa ' + fieldLabel(item) + ' para continuar.';
      if (type === 'phone') msg = 'Ingresa un teléfono válido de 10 números.';
      var note = item.querySelector('._rsi-modal-fields-item-error-text');
      if (!note) {
        note = document.createElement('p');
        note.className = '_rsi-modal-fields-item-error-text';
        item.appendChild(note);
      }
      if (!(note.textContent || '').trim()) note.textContent = msg;
    });
    if (items.length && items[0].scrollIntoView) {
      items[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }

  var lockedScroll = 0;
  var scrollLocked = false;

  function isShown(el) {
    if (!el) return false;
    if (el.classList.contains('_rsi-cod-form-modal-open')) return true;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && el.getClientRects().length > 0;
  }

  function syncScrollLock() {
    var open = isShown(document.getElementById('_rsi-cod-form-modal')) || isShown(document.getElementById('_rsi-cod-form-modal-upsell'));
    if (open && !scrollLocked) {
      lockedScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.top = '-' + lockedScroll + 'px';
      document.body.classList.add('sv-hs-lock');
      document.documentElement.classList.add('sv-hs-lock');
      scrollLocked = true;
    } else if (!open && scrollLocked) {
      document.body.classList.remove('sv-hs-lock');
      document.documentElement.classList.remove('sv-hs-lock');
      document.body.style.top = '';
      window.scrollTo(0, lockedScroll);
      scrollLocked = false;
    }
  }

  function watchSubmit() {
    if (document.documentElement.dataset.svHsSubmit) return;
    document.documentElement.dataset.svHsSubmit = '1';
    window.addEventListener('click', function (event) {
      if (!isTarget()) return;
      var btn = event.target.closest('._rsi-modal-submit-button, ._rsi-buy-now-custom-additionals-button');
      if (!btn || isNoThanks(btn) || !btn.closest('#_rsi-cod-form-modal-form')) return;
      var box = activeVariantBox(btn.closest('#_rsi-cod-form-modal-form'));
      if (box) {
        commitRows(box);
        if (!selectionReady(box)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showSelectionError(box);
          return;
        }
        clearSelectionError(box);
      }
      setTimeout(function () {
        var form = document.querySelector('#_rsi-cod-form-modal-form');
        if (form) explainErrors(form);
      }, 60);
    }, true);
  }

  function paint() {
    if (!isTarget()) return;
    markBody();
    syncScrollLock();
    watchSubmit();
    paintBuyButton();
    paintPayButtons();
    hideAviso(document);
    pinUpsellFirstImage();
    var form = document.querySelector('#_rsi-cod-form-modal-form');
    if (!form) return;
    paintHeader(form);
    placePlaques(form);
    paintBadge(form);
    paintPayButtons();
    enhancePhone(form);
    enhanceKeyboardFlow(form);
    polishShippingRate(form);
    enhanceVariants(form);
  }

  function boot() {
    if (!isTarget() && productId() && !isListedProduct()) return;
    markBody();
    paint();
    var queued = false;
    function relevant(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var node = mutations[i].target;
        var el = node && node.nodeType === 1 ? node : (node && node.parentElement);
        if (!el || !el.closest) return true;
        if (el.closest('._rsi-quantity-offers, ._rsi-modal-submit-button, ._rsi-buy-now-button')) return true;
        if (el.closest('input, textarea')) continue;
        return true;
      }
      return false;
    }
    function needsWork() {
      var form = document.querySelector('#_rsi-cod-form-modal-form');
      if (!form) return false;
      var box = activeVariantBox(form);
      if (box && !box.querySelector('.sv-hs-same')) return true;
      if (isKitProduct() && box && !box.querySelector('.sv-hs-chips[data-sv-opt="0"] .sv-hs-chip')) return true;
      var phone = form.querySelector('input[data-type="phone"]');
      if (phone && !phone.dataset.svHsPhone) return true;
      var btn = form.querySelector('._rsi-modal-submit-button, ._rsi-buy-now-custom-additionals-button');
      if (btn && btn.dataset.svColored !== '1') return true;
      return false;
    }
    var obs = new MutationObserver(function (mutations) {
      if (!relevant(mutations) || queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        if (isTarget()) paint();
      }, 120);
    });
    obs.observe(document.body, { childList: true, subtree: true });
    var tries = 0;
    var late = setInterval(function () {
      tries++;
      if (isTarget() && needsWork()) paint();
      if (tries > 25) clearInterval(late);
    }, 400);
    setInterval(function () {
      if (!isTarget()) return;
      var form = document.querySelector('#_rsi-cod-form-modal-form');
      if (!form || form.offsetParent === null) return;
      paintHeader(form);
    }, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
